exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".navbar-version{font-size:10px;color:#ccc}.jh-navbar{background-color:#353d47;padding:.2em 1em}.jh-navbar .profile-image{margin:-10px 0;height:40px;width:140px;border-radius:50%}.jh-navbar .dropdown-item.active,.jh-navbar .dropdown-item.active:focus,.jh-navbar .dropdown-item.active:hover{background-color:#353d47}.jh-navbar .dropdown-toggle:after{margin-left:.15em}.jh-navbar ul.navbar-nav{padding:.5em}.jh-navbar .navbar-nav .nav-item{margin-left:1.5rem}.jh-navbar a.nav-link{font-weight:400}.jh-navbar .jh-navbar-toggler{color:#ccc;font-size:1.5em;padding:10px}.jh-navbar .jh-navbar-toggler:hover{color:#fff}@media screen and (max-width:992px){.jh-logo-container{width:100%}}.navbar-title{display:inline-block;vertical-align:middle}.navbar-brand.logo{padding:5px 15px}.logo .logo-img{height:45px;display:inline-block;vertical-align:middle;width:140px}.logo-img{height:100%;background-size:contain;width:100%}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./src/main/webapp/app/layouts/navbar/navbar.css
// module id = 242
// module chunks = 0